import { gql } from "@apollo/client";

export const CREATE_CHART_OF_ACCOUNT = gql`
  mutation CreateChartOfAccount($input: ChartOfAccountInput) {
    createChartOfAccount(input: $input) {
      status
      message
    }
  }
`;

export const GET_ACCOUNT_TYPE = gql`
  query Query {
    getAccountType
  }
`;

export const GET_CHART_OF_ACCOUNT_WITH_PAGINATION = gql`
  query GetChartOfAccountWithPagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
    $accountType: String
  ) {
    getChartOfAccountWithPagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
      account_type: $accountType
    ) {
      data {
        _id
        account_type
        account_name
        code_account
        total_credit
        total_debit
        total_balance
        account_description
        is_parents
        is_top_parents
        sub_account {
          _id
          account_type
          account_name
          code_account
          total_credit
          total_debit
          total_balance
          account_description
          is_parents
          is_top_parents
          sub_account {
            _id
            account_type
            account_name
            code_account
            total_credit
            total_debit
            total_balance
            account_description
            is_parents
            is_top_parents
            sub_account {
              _id
              account_type
              account_name
              code_account
              total_credit
              total_debit
              total_balance
              account_description
              is_parents
              is_top_parents
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        parents_account {
          _id
          account_type
          account_name
          code_account
          total_credit
          total_debit
          total_balance
          account_description
          is_parents
          is_top_parents
          createdAt
          updatedAt
        }
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_CHART_OF_ACCOUNT = gql`
  mutation UpdateChartOfAccount(
    $chartAccountId: ID!
    $input: ChartOfAccountInput
  ) {
    updateChartOfAccount(chart_account_id: $chartAccountId, input: $input) {
      status
      message
    }
  }
`;

export const DELETE_CHART_OF_ACCOUNT = gql`
  mutation DeleteChartOfAccount($chartAccountId: ID!) {
    deleteChartOfAccount(chart_account_id: $chartAccountId) {
      status
      message
    }
  }
`;

export const GET_CHART_OF_ACCOUNT_LIST = gql`
  query GetChartOfAccountList($accountType: [String]) {
    getChartOfAccountList(account_type: $accountType) {
      _id
      account_type
      account_name
      code_account
      total_credit
      total_debit
      total_balance
      account_description
      is_parents
      is_top_parents
      parents_account {
        _id
        account_type
        account_name
        code_account
        total_credit
        total_debit
        total_balance
        account_description
        is_parents
        is_top_parents
        parents_account {
          _id
          account_type
          account_name
          code_account
          total_credit
          total_debit
          total_balance
          account_description
          is_parents
          is_top_parents
          createdAt
          updatedAt
        }
        sub_account {
          _id
          account_type
          account_name
          code_account
          total_credit
          total_debit
          total_balance
          account_description
          is_parents
          is_top_parents
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      sub_account {
        _id
        account_type
        account_name
        code_account
        total_credit
        total_debit
        total_balance
        account_description
        is_parents
        is_top_parents
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
